function cleanEmptyCollapse() {
  document.querySelectorAll('.xo-product-info-content__collapse').forEach(collapse => {
    const trigger = collapse.querySelector('.xo-collapse__trigger-title');
    if (trigger && trigger.textContent.trim() === '') {
      collapse.remove();
    }
  });
}
document.addEventListener('DOMContentLoaded', cleanEmptyCollapse);

function replacePoweredBy() {
  const el = document.querySelector('.xo-footer-1__copy-right');
  if (el) {
    // Check if it contains "Powered by"
    if (el.textContent.includes("Powered by Shopify")) {
      // Replace only that text with your link
      el.innerHTML = el.innerHTML.replace(
        /Powered by Shopify/i,
        '<a target="_blank" href="https://plaimanas.com/" class="custom-footerLink">WEB BY ::*</a>'
      );
    }
  }
}

// Run after DOM is ready
document.addEventListener('DOMContentLoaded', replacePoweredBy);